var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Refresh = function Refresh(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.013 19a7.054 7.054 0 0 0 4.654-1.733 6.99 6.99 0 0 0 2.342-4.358 1 1 0 1 1 1.982.261 8.99 8.99 0 0 1-3.01 5.605A9.054 9.054 0 0 1 12.007 21a9.054 9.054 0 0 1-5.96-2.26A8.974 8.974 0 0 1 4.566 6.937a9.034 9.034 0 0 1 5.22-3.654 9.065 9.065 0 0 1 6.338.692A9.027 9.027 0 0 1 19 6.27V4.04a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1H14.979a1 1 0 1 1 0-2h2.855a7.023 7.023 0 0 0-2.613-2.28 7.065 7.065 0 0 0-4.94-.538 7.034 7.034 0 0 0-4.064 2.843A6.974 6.974 0 0 0 7.37 17.24 7.054 7.054 0 0 0 12.013 19Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Refresh;